function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero",
  stroke: "#000",
  strokeWidth: 0.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.068 1.074a.25.25 0 0 0-.354 0L7.41 6.375h.714l4.765-4.771.764.763-4.008 4.008h.708l3.654-3.654 2.388 2.389-1.271 1.265h.708l1.088-1.089a.25.25 0 0 0 0-.353l-3.853-3.86zM16.572 6.971a.25.25 0 0 0-.197-.096h-11a.25.25 0 0 0-.242.31l1.484 6a.25.25 0 0 0 .243.19h8.03a.25.25 0 0 0 .242-.19l1.486-6a.25.25 0 0 0-.045-.214zm-1.878 5.904H7.056l-1.361-5.5h10.361l-1.362 5.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.25 6.031a.25.25 0 0 0 .25-.25v-.266a1.015 1.015 0 0 1 2-.25l2.25 8.919a.25.25 0 0 0 .235.191h8.155a.25.25 0 1 0 0-.5H6.18l-2.197-8.73A1.515 1.515 0 0 0 1 5.515v.266c0 .138.112.25.25.25zM7.5 16.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5zm0-1a.25.25 0 1 1 0 .5.25.25 0 0 1 0-.5zM12.5 14.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5zm0 1a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5z"
}));

var SvgPurchasesSvg = function SvgPurchasesSvg(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPurchasesSvg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/purchasesSvg.ebf77d46.svg";
export { ForwardRef as ReactComponent };